import { __assign, __read } from "tslib";
import React, { useState } from 'react';
import ModalDialog, { ModalTransition, } from '@atlaskit/modal-dialog';
import { Header } from './ModalHeader';
import { ModalBody } from './ModalBody';
var Modal = function (_a) {
    var onClose = _a.onClose, onOpen = _a.onOpen, src = _a.src, showModal = _a.showModal, providerName = _a.providerName, closeLabel = _a.closeLabel, iframeName = _a.iframeName;
    var _b = __read(useState(showModal), 2), isOpen = _b[0], setIsOpen = _b[1];
    return (React.createElement(ModalTransition, null, isOpen && (React.createElement(ModalDialog, { height: "100%", width: "large", onOpenComplete: onOpen, components: {
            Body: ModalBody,
            Header: function (props) { return (React.createElement(Header, __assign({}, props, { title: providerName, label: closeLabel }))); },
        }, onClose: function () {
            setIsOpen(false);
        }, onCloseComplete: onClose }, src ? (React.createElement("iframe", { style: { width: '100%', height: '100%' }, name: iframeName, frameBorder: 0, src: src })) : (React.createElement("iframe", { style: { width: '100%', height: '100%' }, name: iframeName, frameBorder: 0 }))))));
};
export default Modal;
//# sourceMappingURL=Modal.js.map